import { Block } from 'webiq.boilerplate'

export default class LpTotop extends Block {
	static title = 'lp-totop'

	init() {
        this.element.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: "smooth" })
        })
	}
}
